import React from 'react';
import { Spin as AntdSpin, type SpinProps as AntdSpinProps } from 'antd';

export type SpinProps = AntdSpinProps;

type SpinComponent = React.ForwardRefExoticComponent<
    SpinProps & React.RefAttributes<HTMLDivElement>
> & {
    setDefaultIndicator: typeof AntdSpin.setDefaultIndicator;
};

// AntD `Spin` is a plain function component and does not accept a `ref`. The
// forwardRef shell preserves the house signature/displayName; the render
// function takes both params so React does not warn, and `_ref` is
// intentionally not forwarded to the underlying Spin.
const Spin = React.forwardRef<HTMLDivElement, SpinProps>((props, _ref) => (
    <AntdSpin {...props} />
)) as SpinComponent;

Spin.displayName = 'Spin';
Spin.setDefaultIndicator = (AntdSpin as typeof AntdSpin | undefined)
    ?.setDefaultIndicator as typeof AntdSpin.setDefaultIndicator;

export { AntdSpin };
export default Spin;
